<template>
 <div class="personal-info">
   <id-validate
     :all-data="allData"
     :card-type-list="cardTypeList"
     @ajax-success="ajaxSuccess"
   ></id-validate>
   <address-validate
     @ajax-success="ajaxSuccess"
     :all-data="allData"
   ></address-validate>
   <investment-experience
     :all-data="allData"
   ></investment-experience>
 </div>
</template>

<script>
import investmentExperience from "@/components/myFiles/personalInfo/investmentExperience";
import addressValidate from "@/components/myFiles/personalInfo/addressValidate";
import { mapGetters } from 'vuex'
import { GetCustInFo } from '@/api/userCenter.js';
import idValidate from "@/components/myFiles/personalInfo/idValidate";
import { certTypes } from '@/assets/codelist/certTypes';
export default {
  name: "personalInformation",
  components:{
    idValidate,
    addressValidate,
    investmentExperience,
  },

  data() {
    return {
      allData:{},
      cardTypeList: [],// 证件类型
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created(){
    this.cardTypeList = certTypes.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.getCustomerInfo();
  },
  methods: {
    ajaxSuccess(){
      this.getCustomerInfo();
    },
    getCustomerInfo(){
      let parmas = {
        custId: this.userInfo.id,
      }
      GetCustInFo(parmas).then((res) => {
        this.allData = res.data;
      })
    },
  },
}
</script>

<style lang="scss">
.personal-info {
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #5E5873;
  }
  .tag-box-id-validate,
  .tag-box-address-validate {
    font-size: 12px;
  }
}
</style>
